"use strict";

$(document).ready(function(){
	// mobile nav
    $('.header__nav--mobile').click(function(){
        $('.hamburger').toggleClass('is-active');
        if($('.hamburger').hasClass('is-active')){
			// $('body').css({'position' : 'fixed'});
			$('.header__nav').css({'display' : 'flex'});
			$('.header__nav--wrap').addClass('is-active');
        } else{
			// $('body').css({'position' : 'relative'});
			$('.header__nav').css({'display' : 'none'});
			$('.header__nav--wrap').removeClass('is-active');
        }
    });

	// media filter
	$('[name="filter"]').change(function(){
		var url = $(this).val();
		window.location.href = url;
	});

	// aos
	AOS.init({
		easing: 'ease',
		duration: 1500
	});

	// anchors
	$(function(){
		$('a[href*="#"]:not([href="#"])').click(function(){
			if(location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname){
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if(target.length){
					$('html, body').animate({
						scrollTop: target.offset().top - 100
					}, 1000);
					return false;
				}
			}
		});
	});
});